module.exports = __webpack_public_path__ + "img/ms_my - 副本.952f085c.png";